import { Layout } from '@/components/Layout/Layout';
import ClientRecipesCategorySlugPage from 'components/PageLevelComponents/ClientRecipesCategorySlugPage';
import type { ISocialMediaComponent } from 'components/SocialMedia/types';
import { ANONYMOUS_TOKEN_NAME, LOCALE_DEFAULT } from 'config/config';
import type { GetServerSideProps } from 'next';
import { RecipesCategoryPageController } from 'server/controller/page/recipes/categoryPageController';
import type { IRecipesCategoryPageResource } from 'server/resource/page/recipesCategoryPageResource';
import type { IGlobalMetaData } from 'types/GlobalMetadata';

const RootPage = (props: IRecipesCategoryPageResource) => {
  const {
    metaData,
    searchItemLabels,
    recipeCopy,
    breadcrumbsCMSData,
    footerNavData,
    footerImage,
    locale,
    searchOverlayData,
    countrySelectorData,
    newsletterData,
    contactUsUrl,
    difficultyCopy,
    getHeaderNav,
    getMobileNavData,
    popularSearchData,
    cardCarouselCMSData,
    recallData,
    recipeEnv,
    dynamicPageComponents,
    searchPageLabels,
    category,
    followUsData,
    host,
    refinementList,
    recipes,
    numberOfRecipes,
    facets,
    pathTranslations,
    userToken,
    globalDictionary,
  } = props;

  return (
    <Layout
      themeName={undefined}
      pathTranslations={pathTranslations}
      locale={locale}
      globalMetadata={metaData}
      getHeaderNav={getHeaderNav}
      getMobileNavData={getMobileNavData}
      popularSearchData={popularSearchData}
      footerNavData={footerNavData}
      footerImage={footerImage}
      searchOverlayData={searchOverlayData}
      countrySelectorData={countrySelectorData}
      newsletterData={newsletterData}
      contactUsUrl={contactUsUrl}
      difficultyCopy={difficultyCopy as Record<string, string>}
      cardCarouselCMSData={cardCarouselCMSData}
      recallData={recallData}
      userToken={userToken}
      globalDictionary={globalDictionary}
    >
      <ClientRecipesCategorySlugPage
        category={category}
        dynamicPageComponents={dynamicPageComponents}
        locale={locale}
        followUsData={followUsData as unknown as ISocialMediaComponent}
        recipeCopy={recipeCopy}
        refinementList={refinementList}
        initialRecipes={recipes}
        initialTotalResults={numberOfRecipes}
        initialFacets={facets}
        host={host}
        recipeEnv={recipeEnv}
        searchItemLabels={searchItemLabels as Record<string, string>}
        breadcrumbsCMSData={breadcrumbsCMSData}
        searchOverlayData={searchOverlayData}
        difficultyCopy={difficultyCopy as Record<string, string>}
        globalMetadata={metaData as IGlobalMetaData}
        searchPageLabels={searchPageLabels as Record<string, string>}
      />
    </Layout>
  );
};

export const getServerSideProps: GetServerSideProps = async ({
  locale,
  params,
  defaultLocale,
  resolvedUrl,
  req,
}) => {
  const anonymousToken = req.cookies[ANONYMOUS_TOKEN_NAME];

  const categoryPageData = await RecipesCategoryPageController.getCachedCategoryPageData({
    resolvedUrl,
    locale: locale || defaultLocale || LOCALE_DEFAULT,
    slug: Array.isArray(params?.slug) ? params.slug.join('/') : (params?.slug ?? ''),
    host: req.headers.host ?? '',
    userToken: anonymousToken ?? '',
  });

  return categoryPageData;
};

export default RootPage;
